import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  BrickListingWithOrWithoutFamilyIdSearchService,
  categoryListingService,
  BrickListingWithOrWithoutFamilyId,
  FamilyListingService,
} from "../../../services/MasterDataManagementService";
import BrickList from "./BrickList";
import useGlobalState from "../../../Context";

const ProductBrick = () => {
  const [brickList, setBrickList] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [categoryList, setCategoryList] = useState([]);
  const [productFamilyList, setProductFamilyList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchBrickListWithorWithoutFamily("brickName", false);
  }, []);

  const fetchBrickListWithorWithoutFamily = async (sortBy, isAsc, id,searchValue,paginationObject ) => {
    try {
      setLoading(true);
      const obj = {
        pageNumber: paginationObject?.pageNumber?? 0,
        pageSize: paginationObject?.pageSize??10,
        filterSearch: searchValue ? searchValue :null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        productFamilyId:  null,
        sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
      };
      const brickListingResponse = await BrickListingWithOrWithoutFamilyId(obj);
      if (brickListingResponse.statusCode === 6) {
        if (brickListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setBrickList(brickListingResponse.data.content);
        setTotalElements(brickListingResponse.data.totalElements);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const onSearch = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: "ASC",
        sortBy: "brickName",
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      const response = await BrickListingWithOrWithoutFamilyIdSearchService(
        requestBody,
        searchValue
      );

      if (response.statusCode === 6) {
        if (response.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setBrickList(response.data.content);
        setTotalElements(response.data.totalElements);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        active: loginUserType === "Main Admin" ? 2 : 0,
        filterSearch: searchValue ? searchValue.trim() : null,
        productFamilyId: null,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        sortBy: orderBy,
      };
      // setTableLoader(true);
      const response = await BrickListingWithOrWithoutFamilyId(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setBrickList([...brickList, ...response.data.content]);
        } else {
          setBrickList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const fetchCategoryList = async () => {
    try {
      const requestBody = {
        pageSize: 1000,
        pageNumber: 0,
        filterSearch: null,
        active: 0,
        sortDirection: "DESC",
        sortBy: "categoryName",
      };
      const categoryListingResponse = await categoryListingService(requestBody);
      if (categoryListingResponse.statusCode === 6) {
        setCategoryList(categoryListingResponse.data);
      } else {
        showNotification("Error", categoryListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchProductFamilyList = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 1000,
        filterSearch: null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        categoryId: id ? id : null,
        sortDirection: "DESC",
        sortBy: "productFamilyName",
      };
      const familyListingResponse = await FamilyListingService(obj);
      if (familyListingResponse.statusCode === 6) {
        setProductFamilyList(familyListingResponse.data);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <BrickList
      totalElements={totalElements}
      setBrickList={setBrickList}
      onSearch={onSearch}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      fetchCategoryList={fetchCategoryList}
      categoryList={categoryList}
      brickList={brickList}
      fetchProductFamilyList={fetchProductFamilyList}
      productFamilyList={productFamilyList}
      fetchBrickListWithorWithoutFamily={fetchBrickListWithorWithoutFamily}
      noRecord={noRecord}
    />
  );
};

export default ProductBrick;
